import { getApiBaseUrl } from './config';

export interface SecretaryUser {
  id: string;
  email: string;
  name: string;
  clinicName: string;
  provider: string;
  patientLanguage?: string;
}

export interface SecretaryVerifyResponse {
  exists: boolean;
  isActive?: boolean;
  user?: SecretaryUser;
  token?: string;
  expiresAt?: number;
}

export const verifySecretaryApi = async (googleToken: string): Promise<SecretaryVerifyResponse> => {
  const response = await fetch(`${getApiBaseUrl()}/secretary/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ idToken: googleToken }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || error.message || 'Failed to verify secretary');
  }
  
  return response.json();
};

export const getSecretaryUserApi = async (email: string): Promise<SecretaryUser | null> => {
  const response = await fetch(`${getApiBaseUrl()}/secretary/${encodeURIComponent(email)}`);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error('Failed to fetch secretary user');
  }
  return response.json();
};

export const createSecretaryUserApi = async (data: {
  email: string;
  name: string;
  clinicName: string;
  provider: string;
  patientLanguage: string;
  idToken: string;
}): Promise<{ secretary: SecretaryUser; token: string; expiresAt: number }> => {
  const response = await fetch(`${getApiBaseUrl()}/secretary/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw Object.assign(new Error(error.error || error.message || 'Failed to create secretary user'), { status: response.status });
  }
  
  return response.json();
};
